import React, { memo, useState } from "react"
import PropTypes from "prop-types"
import Img from "gatsby-image"
import PopupWindow, { invokePopup } from "../../shared/PopupWindow"
import styled from "@emotion/styled"
import { breakpoints, color } from "../../../utils/style"
import IcomoonIcon from "../../shared/IcomoonIcon"

const GameWrapper = styled("div")`
  display: flex;
  flex-flow: row wrap;
`

const GameAd = styled("a")`
  width: calc(94%/4);
  margin: 0 20px 20px 0;
  position: relative;
  &:nth-of-type(4n) {
    margin-right: 0;
    .play-cta {
      right: 0;
    }
  }
  .play-cta {
    position: absolute;
    top: 45%;
    left: 0;
    right: 20px;
    width: 140px;
    margin: -34px auto 0;
    padding: 15px;
    display: none;
  }
  &:hover,
  &:active {
    text-decoration: none;
    .play-cta {
      display: inline-block;
      z-index: 1;
    }
    img {
      filter: brightness(20%);
    }
  }
  .game-name {
    display: inline-block; 
    color: ${color.white};
    font-size: 15px;
    line-height: 24px;
    margin-top: 16px;
  }

  @media (max-width: ${breakpoints.md}) {
    width: calc(90%/4);
    margin: 0 18px 18px 0;
    &:nth-of-type(4n) {
      margin-right: 0;
      .play-cta {
        right: 0;
      }
    }
  }

  @media (max-width: ${breakpoints.sm}) {
    width: calc(95%/2);
    margin: 0 10px 10px 0;
    &:nth-of-type(2n) {
      margin-right: 0;
      .play-cta {
        right: 0;
      }
    }
    .play-cta {
      font-size: 13px;
      padding: 8px 10px;
      width: 90px;
      margin: -24px auto 0;
    }
    &.jackpot-slide {
      .play-cta {
        margin-top: -20px;
      }
    }
    .game-name {
      margin-top: 8px;
    }
  }
`

const DemoGamesWrap = styled("div")`
  .login-register-prompt {
    position: absolute;
    top: 28px;
    left: 0;
    bottom: 0;
    right: 0;
    padding: 20px 7%;
    text-align: center;
    background: rgba(0, 0, 0, 0.8);
    z-index: 1;
  }
  .mobile-rotate {
    display: none;
    text-align: center;
  }
  .waiting {
    position: relative;
    .h3 {
      padding: 0;
      text-align: center;
      max-width: 100%;
      margin-bottom: 5%;
    }
    .bottom-buttons {
      margin-top: 5%;
      .button {
        margin: 10px;
      }
    }
  }

  @media (max-width: ${breakpoints.md}) {
    .mobile-rotate {
      display: block;
      position: absolute;
      top: 30%;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 10;
    }
    .mobile-rotate + .iframe-container, .login-register-prompt {
      opacity: 0;
      visibility: hidden;
    }
    .waiting {
      .timer-wrap, .h3 {
        position: static;
      }
    }
    .login-register-prompt {
      top: 0;
    }
    .iframe-container {
      width: auto;
      position: static;
      overflow: auto;
      padding: 0;
      iframe {
        position: static;
        height: 98vh;
      }
    }
  }
  @media (orientation: landscape) {
    .mobile-rotate { display: none; }
    .mobile-rotate + .iframe-container, .login-register-prompt {
      opacity: 1;
      visibility: visible;
    }
  }
`

const FilterButtonGroup = styled("div")`
  margin-bottom: 48px;
  .filter-button {
    background: transparent;
    border: none;
    color: ${color.white};
    font-size: 14px;
    line-height: 18px;
    text-transform: uppercase;
    padding: 4px 0;
    margin-right: 32px;
    cursor: pointer;
    transition: 0.15s text-shadow linear;
    &:last-child {
      margin: 0;
    }
    &:hover,
    &.active {
      text-shadow: 0 0 1px ${color.white}, 0 0 1px ${color.white};
      border-bottom: 2px solid ${color.pink};
    }
  }
  .mobile-button-filter {
    display: none;
  }
  .account-accordion {
    position: relative;
    width: 70%;
    .accordion-title {
      transition: 0.5s;
      padding: 4px 50px 4px 0;
      color: ${color.white};
      background: transparent;
      font-size: 16px;
      border-radius: 0;
      text-transform: uppercase;
      min-width: 150px;
      border-bottom: 2px solid ${color.pink};
      &::after {
        padding: 5px;
        top: 4px;
        right: 10px;
        left: auto;
        border-color: ${color.white};
      }
    }
    .accordion-content {
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 1;
      overflow: hidden;      
      height: auto;
      padding: 0;
      width: 100%;
      ul {
        background: ${color.white};
        padding: 0;
        border-radius: 24px;
        li {
          list-style: none;
          padding: 0;
          margin: 0;
          text-align: left;
          color: ${color.white};
          font-size: 14px;
        }
      }      
    }
    .a {
      display: block;
      width: 100%;
      padding: 10px 16px;
      border-bottom: 1px solid ${color.white}; 
      border-color: ${color.white};
      border-width: 0 0 1px 0;
      outline: none;
      border-radius: 0;
      color: ${color.pink};
      background: ${color.white};
      font-size: 0.9rem;
      text-transform: uppercase;
      cursor: pointer;
      text-align: left;
      &.current {
        display: none;
      }
    }
    &.accordion-open {
      .accordion-title {
        &::after {
          transform: rotate(-135deg);
          top: 8px;
        }
      }
      .accordion-content {
        display: block;
      }
    }
  }
  @media (max-width: ${breakpoints.md}) {
    .filter-button {
      display: none;
    }
    .mobile-button-filter {
      display: block;
    }
  }
`

const Demo10Games = ({ demoGameUrl, slotSlides }) => {
  const demoClickHandler = (e, popupId, gameTitle, gameLink) => {
    invokePopup(e, popupId)
    const gameIframe = document.getElementById("game-home-iframe")
    gameIframe.src = gameLink || demoGameUrl
    const gamePopupTitle = document.getElementById(popupId + "-title")
    if (gamePopupTitle && gameTitle) {
      gamePopupTitle.innerHTML = gameTitle
    }
  }

  const [gameCategory, setGameCategory] = useState("Slot Games");
  const [isActiveTab, setIsActiveTab] = useState(false);


  return (
    <DemoGamesWrap>
      <h2 className="h1 rich-design">
        <span>ประเภทเกมที่สนุกได้บน SCR888</span>
      </h2>
      <div className="decorative-line" />

      <FilterButtonGroup>
        <button className={`filter-button ${gameCategory === 'Slot Games' ? 'active' : ''}`} onClick={() => (setGameCategory('Slot Games'))}>Slot Games</button>
        <button className={`filter-button ${gameCategory === 'Arcade Games' ? 'active' : ''}`} onClick={() => (setGameCategory('Arcade Games'))}>Arcade Games</button>
        <button className={`filter-button ${gameCategory === 'Shooting Games' ? 'active' : ''}`} onClick={() => (setGameCategory('Shooting Games'))}>Shooting Games</button>
        <button className={`filter-button ${gameCategory === 'Table Games' ? 'active' : ''}`} onClick={() => (setGameCategory('Table Games'))}>Table Games</button>
        <div className={`mobile-button-filter`}>
          <div className={`accordion account-accordion ${isActiveTab ? 'accordion-open' : ''}`}>
            <div className="accordion-title" role="button" tabIndex={0} onKeyDown={() => (setIsActiveTab(!isActiveTab))} onClick={() => (setIsActiveTab(!isActiveTab))}>{gameCategory}</div>
            <div className="accordion-content">
              <ul>
                <li>
                  <button className={`a ${gameCategory === 'Slot Games' ? 'current' : ''}`} onClick={() => {setGameCategory('Slot Games'); setIsActiveTab(!isActiveTab)}}>Slot Games</button>
                </li>
                <li>
                  <button className={`a ${gameCategory === 'Arcade Games' ? 'current' : ''}`} onClick={() => {setGameCategory('Arcade Games'); setIsActiveTab(!isActiveTab)}}>Arcade Games</button>
                </li>
                <li>
                  <button className={`a ${gameCategory === 'Shooting Games' ? 'current' : ''}`} onClick={() => {setGameCategory('Shooting Games'); setIsActiveTab(!isActiveTab)}}>Shooting Games</button>
                </li>
                <li>
                  <button className={`a ${gameCategory === 'Table Games' ? 'current' : ''}`} onClick={() => {setGameCategory('Table Games'); setIsActiveTab(!isActiveTab)}}>Table Games</button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </FilterButtonGroup>

      {slotSlides.length > 0 && (
        <GameWrapper className="demo-games-row">
          {slotSlides
            .filter((item) => (gameCategory === 'Slot Games' ? slotSlides.length > 0 : item.acf.slide_description.toLowerCase() === gameCategory.toLowerCase()))
            .map((item) => (
            <GameAd
              className="demo-game-slide"
              key={item.id}
              onClick={e =>
                demoClickHandler(
                  e,
                  "demo-home-popup",
                  item.alt_text,
                  item.acf.slide_url
                )
              }
              href={
                item.acf && item.acf.slide_url.indexOf("http") !== -1
                  ? item.acf.slide_url
                  : process.env.URL + item.acf.slide_url
              }
            >
              {item.localFile && item.localFile.childImageSharp.fluid && (
                <Img
                  fluid={item.localFile.childImageSharp.fluid}
                  alt={item.altText ? item.altText : "SCR888-VIP"}
                  fadeIn={false}
                  loading="eager"
                />
              )}
              {item.alt_text && <span className="game-name">{item.alt_text}</span>}
              <span className="play-cta button pink-button">เล่นเลย</span>
            </GameAd>
          ))}
        </GameWrapper>
      )}
      <PopupWindow
        title="เกมตัวอย่าง"
        popupId="demo-home-popup"
        extraClass="wide title-orange custom-game-popup"
      >
        <div className="mobile-rotate">
          <IcomoonIcon icon="mobile-rotate" color={color.pink} size={80}/>
          <p>Please rotate your device</p>
        </div>
        <div className="iframe-container">
          <iframe title="Demo Game" id="game-home-iframe" src="" />
        </div>
      </PopupWindow>
    </DemoGamesWrap>
  )
}

export default memo(Demo10Games)

Demo10Games.propTypes = {
  sliderSettings: PropTypes.object,
  demoGameUrl: PropTypes.string,
  slotSlides: PropTypes.arrayOf(
    PropTypes.shape({
      acf: PropTypes.shape({
        slide_description: PropTypes.string,
        slide_title: PropTypes.string,
        slide_url: PropTypes.string,
      }),
      alt_text: PropTypes.string,
      id: PropTypes.string,
      title: PropTypes.string,
    })
  ),
}

